'use strict';

/* jshint -W098 */
angular.module('mean.trades').controller('TradeShortcutsController', ['$scope', 'Global', 'MeanUser', 'toaster', '$filter', 'tradeCodeService', 'userService', 'TradeBids', 'bidTotalsService', 'taskTotalsService', 'shortcutService',
  function($scope, Global, MeanUser, toaster, $filter, tradeCodeService, userService, TradeBids, bidTotalsService, taskTotalsService, shortcutService) {
    $scope.global = Global;
    $scope.package = {
      name: 'trades'
    };

    console.log('in the shortcut controller');

    $scope.user = MeanUser.user;
    $scope.matrix_values = [];
    $scope.matrix_subtasks = [];

    $scope.$on('updateSubtaskShortcuts', function(event, data) { 
        $scope.my_bid_tasks = $filter('filter')(data.task_list, 
            {'trade': tradeCodeService.getCode($scope.user.trade[0])}, true);

        $scope.matrix_subtasks = shortcutService.buildMatrixSubtasks(
                $scope.my_bid_tasks);
        
        $scope.updateShortcuts();
    });

    userService.getMainAccount($scope.user.username).then(function(main_user) {
        //Trades.query({'main_account_id': main_user._id}, function(trade) {
            //$scope.my_trade = trade;

            TradeBids.query({'bid_id': $scope.bid._id, 'username': main_user.username}, function(trade_bid) {
                if(trade_bid.length !== 1) {
                    toaster.pop('error', 'Bid Trade', 'There is a problem with the bid trade.  Contact Admin');
                    return;
                }
                $scope.my_bid = trade_bid[0];

                if($scope.my_bid.trade !== $scope.user.trade[0]) {
                    toaster.pop('error', 'Bid Trade', 'There is a problem with the bid trade.  Contact Admin');
                    return;
                }

                $scope.my_bid_tasks = $filter('filter')($scope.my_bid.task_list, 
                    {'trade': tradeCodeService.getCode($scope.user.trade[0])}, true);

                $scope.matrix_subtasks = shortcutService.buildMatrixSubtasks(
                    $scope.my_bid_tasks);

            //$scope.matrix_subtasks = $scope.my_trade.subtasks;

                $scope.matrix_plans = angular.copy($scope.filteredMenuItems());

                $scope.updateShortcuts();
            });
        //});
    });

    $scope.filterItems.push("Cover");
    
    $scope.filteredMenuItems = function() {
        return $scope.bid_menu.filter(function(item) {
            return $scope.filterItems.indexOf(item.item) === -1;
        });
    };

    $scope.updateShortcuts = function() {
        $scope.matrix_subtasks = shortcutService.updateShortcuts(
            $scope.matrix_plans, $scope.matrix_subtasks,
            $scope.my_bid_tasks, $scope.my_bid.bid);

        $scope.$emit('updatedTradeBid', $scope.my_bid);
    };

    $scope.updateTasks = function() {
        userService.getMainAccount($scope.user.username).then(function(main_user) {
            TradeBids.query({'bid_id': $scope.bid._id, 'username': main_user.username}, function(trade_bid) {
                if(trade_bid.length !== 1) {
                    toaster.pop('error', 'Bid Trade', 'There is a problem with the bid trade.  Contact Admin');
                    return;
                }
                $scope.my_bid = trade_bid[0];

                if($scope.my_bid.trade !== $scope.user.trade[0]) {
                    toaster.pop('error', 'Bid Trade', 'There is a problem with the bid trade.  Contact Admin');
                    return;
                }

                $scope.my_bid_tasks = $filter('filter')($scope.my_bid.task_list, 
                    {'trade': tradeCodeService.getCode($scope.user.trade[0])}, true);

                for(var i=0; i<$scope.matrix_plans.length; i++) {
                    for(var j=0; j<$scope.my_bid_tasks.length; j++) {
                        var subs = $filter('filter')($scope.matrix_subtasks, {
                            'task': $scope.my_bid_tasks[j].task }, true);

                        var mat_total = 0;
                        var eq_total = 0;
                        var lab_total = 0;
                        for(var k=0; k<subs.length; k++) {
                            var vals = $filter('filter')(subs[k].values, {
                                'plan_code': $scope.matrix_plans[i].item }, true);

                            var subt = $filter('filter')($scope.my_bid_tasks[j].subtasks, {
                                '_id': subs[k]._id}, true);

                            subt[0].bid_hours = 0;
                            subt[0].quantity = vals[0].quantity;
                            subt[0].hours_allowed = Number(bidTotalsService.getHoursAllowedForItem(subt[0]));
                            subt[0].labor = taskTotalsService.getCurrentNetPay(
                                subt[0].hours_allowed, subt[0].crew_rate, subt[0].quantity, subt[0].piece_rate);

                            lab_total += subt[0].labor;
                            for(var l=0; l<subt[0].materials.length; l++) {
                                subt[0].materials[l].quantity = 0;

                                if($scope.my_bid_tasks[j].unit === subt.unit) {
                                    if(subt[0].materials[l].is_overridden) {
                                        subt[0].materials[l].quantity_allowed = 
                                            subt[0].materials[l].overridden_quantity;
                                    } else {
                                        subt[0].materials[l].quantity_allowed = 
                                            bidTotalsService.getQuantityAllowed(subt[0], subt[0].materials[l]);
                                    }
                                }

                                mat_total += bidTotalsService.getMaterialTotal(subt[0], subt[0].materials[l]);
                            }

                            for(var l=0; l<subt[0].equipment.length; l++) {
                                subt[0].equipment[l].quantity = 0;

                                if($scope.my_bid_tasks[j].unit === subt.unit) {
                                    if(subt[0].equipment[l].is_overridden) {
                                        subt[0].equipment[l].quantity_allowed = 
                                            subt[0].equipment[l].overridden_quantity;
                                    } else {
                                        subt[0].equipment[l].quantity_allowed = 
                                            bidTotalsService.getQuantityAllowed(subt[0], subt[0].equipment[l]);
                                    }
                                }

                                eq_total += bidTotalsService.getMaterialTotal(subt[0], subt[0].equipment[l]);
                            }
                        }

                        if(!$scope.my_bid_tasks[j].materials) $scope.my_bid_tasks[j].materials = 0;
                        if(!$scope.my_bid_tasks[j].labor) $scope.my_bid_tasks[j].labor = 0;
                        if(!$scope.my_bid_tasks[j].equipment) $scope.my_bid_tasks[j].equipment = 0;

                        bidTotalsService.updateBid($scope.my_bid_tasks[j], 
                            $scope.matrix_plans[i].item, $scope.my_bid.bid);

                        $scope.my_bid_tasks[j].labor += lab_total;
                        $scope.my_bid_tasks[j].materials += mat_total;
                        $scope.my_bid_tasks[j].equipment += eq_total;
                    }
                }

                $scope.my_bid.$update(function(res) {
                    $scope.$emit('updatedTradeTasks', res);
                });
            });
        });
    };

    $scope.fileSelected = function() {
        var lines, lineNumber, data, length;
        
        lines = this.$parent.fileContent.split('\n');
        lineNumber = 0;
        var checked = false;
        var size = 0;
        //var holder = [];

        var test_length = lines.length;

        //check if the last line is empty
        if(lines[test_length-1] == '') {
            test_length -= 1;
        }

        //lines is the number of entries plus the header line
        if($scope.matrix_subtasks.length != test_length-1) {
            toaster.pop('error', 'Matrix Value Error', 
                'Subtasks in bid (' + parseInt($scope.matrix_subtasks.length) + 
                ') and number of subtasks (' + parseInt(test_length-1) + ') in file do not match.');
            return;
        }

        for (var i = lines.length - 1; i > 0; i--) {
            var l = lines[i];

            lineNumber++;
            data = l.split(',');

            if(!data[0]) continue; 

            if(!checked) {
                size = data.length;
                checked = true;
            } else {
                if(size !== data.length) {
                    toaster.pop('error', 'File Input Error', 'Make sure you do not have commas');
                    return;
                }
            }

            //might want to enable this later.  This will allow the user
            //to update the bid note when importing but it needs to be
            //connected further down the line when an update occurs
            //because the change does not make it to the database.
            //$scope.matrix_subtasks[i-1].note = data[1];
            for(var j=0; j<$scope.matrix_subtasks[i-1].values.length; j++) {
                $scope.matrix_subtasks[i-1].values[j].quantity = data[j+2];
            }
        }

        delete this.$parent.fileContent;
    };

    $scope.ConvertToCSV = function(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = 'Subtask,Bid Labor Note';
        for(var i=0; i<$scope.matrix_plans.length; i++) {
            str += ',' + $scope.matrix_plans[i].item;
        }
        str += '\r\n';

        for(var i=0; i<array.length; i++) {
            str += array[i].trade + array[i].task + ': ' + array[i].name + ',' + array[i].note + ',';
            for(var j=0; j<array[i].values.length; j++) {
                str += array[i].values[j].quantity;

                if(j<array[i].values.length-1)
                    str += ',';
            }
            str += '\r\n';
        }

        return str;
    };

    $scope.exportFile = function() {
        var dataUrl = 'data:text/csv;utf-8,' + encodeURI($scope.ConvertToCSV($scope.matrix_subtasks));
        var link = document.createElement('a');
      
        angular.element(link)
            .attr('href', dataUrl)
            .attr('download', 'shortcuts_matrix.csv'); // Pretty much only works in chrome
      
        link.click();
    };

    $scope.deleteAll = function() {
        for(var i=0; i<$scope.matrix_subtasks.length; i++) {
            for(var j=0; j<$scope.matrix_subtasks[i].values.length; j++) {
                $scope.matrix_subtasks[i].values[j].quantity = 0;
            }
        }
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/trades/public/controllers/tradeShortcuts.js